import {SelectSolutionComponent} from "./select-solution/select.solution.component";
import {AssistantAppearanceComponent} from "./assistant-interface/assistant.appearance.component";
import {VisibilitySwitchComponent} from "./visibility-switch/visibility.switch.component";
import {GrayTileComponent} from "./gray-tile/gray.tile.component";
import {SwitcherComponent} from "./base/switcher.component";
import {TabControlComponent} from "./base/tab.control.component";
import {OurPartnersPage} from "./pages/our-partners/our-partners.page";
import {
  SuccessfulImplementationStories
} from "./pages/successful-implementation-stories/successful.implementation.stories";
import {ControlMenuTreeComponent} from "./base/control.menu.tree.component";
import {SearchContentComponent} from "./base/search.content.component";
import {PricesSliderPage} from "./pages/prices/prices.page";
import {FeedbackComponent} from "./feedback/feedback.component";
import {PriceStore} from "./store/price.store";
import {FeedbackSendPage} from "./pages/feedback/feedback.send.page";
import {CompaniesAnimationComponent} from "./animations/companies.animation.component";
import {LicenseAnimationComponent} from "./animations/license-animation/license.animation.component";
import {ModalComponent} from "./base/modal/modal.component";
import {NewsPage} from "./pages/news/news.page";
import {FeedbackPlaceholderComponent} from "./feedback/feedback.placeholder.component";
import {PressCenterPage} from "./pages/press.center.page";
import {UploadFileComponent} from "./base/upload-file/upload.file.component";
import {SwiperSettings} from "./common/swiper.settings";
import {NewsCategories} from "./pages/news/news.category";
import {NewsPageService} from "./pages/news/service/news.page.service";
import {InterfaceCategories, InterfaceNews} from "./interface/press-center/interface.news";
import {NewsBody} from "./pages/news/news.body";
import {NewsCategoryService} from "./pages/news/service/news.category.service";
import {NewsStore} from "./store/news.store";
import {NewsSearch} from "./pages/news/news.search";
import {MediaPageService} from "./pages/media/service/media.page.service";
import {InterfaceMedia} from "./interface/press-center/interface.media";
import {MediaPage} from "./pages/media/media.page";
import {MediaBody} from "./pages/media/media.body";
// import { AnimationMainPage } from './animations/animation-main-page';
import { PromotionsPage } from './pages/promotions/promotions.page';
import { PanelMenuComponent } from './components/menu/panel.menu.component';
import { OnePageMenuComponent } from './components/menu/one.page.menu.component';
import { ComparisonEditionsPage } from './pages/сomparison-editions/сomparison.editions.page';
import {NewsItemPage} from "./pages/news/news.item.pege";
import {DownloadStore} from './store/download.store';
import { currentUrl, searchParams } from './common/consts';
import { PanelCookiesComponent } from './components/panel.cookies.component';
import {SmoothTransitionAnchorLinks} from "./base/smooth.transition.anchor.links";
import { InvoicingPage } from './pages/invoicing/invoicing.page';
// import moment, {Moment} from 'moment';

class App {
  private interfaceTabs: HTMLElement[];
  private tabControls: HTMLElement[];
  private visibilitySwitches: HTMLElement[];
  private grayTiles: HTMLElement[];
  private switchers: HTMLElement[];
  private controlMenuTreeItems: HTMLElement[];
  private sliders: HTMLElement[];
  // private feedbackItems: HTMLElement[];
  private loader: HTMLElement | null;
  private feedbackSend: HTMLFormElement | null;
  private sidePopup: HTMLElement | null;
  private tabContentSliders: HTMLElement[];
  private usingCompanies: HTMLElement[];
  private canvasLicense: HTMLCanvasElement | null;
  private modalOpenItems: HTMLElement[];
  private modal: HTMLElement | null
  private newsCategories: HTMLElement[];
  private news: HTMLElement | null;
  private pressCenterNews: HTMLElement[];
  private pressCenterSearch: HTMLElement | null
  private pressCenterMedia: HTMLElement[];
  private media: HTMLElement | null;
  private buttonBack: HTMLElement | null;
  private animationWordsWindow: HTMLElement | null;
  private panelMenus: HTMLElement[]
  private onePageMenus: HTMLElement[];
  private comparisonEditions: HTMLElement | null;
  private newsUnit: HTMLElement | null;
  private consentUseCookies:HTMLElement | null;
  private formInvoicing: HTMLFormElement | null;

  constructor() {
    this.tabControls = Array.prototype.slice.call(document.querySelectorAll('[data-tabs="container"]'));
    this.interfaceTabs =
        Array.prototype.slice.call(document.querySelectorAll('[data-interface-tabs="container"]'));
    this.visibilitySwitches =
        Array.prototype.slice.call(document.querySelectorAll('[data-visibility-switch-item="container"]'));
    this.grayTiles =
        Array.prototype.slice.call(document.querySelectorAll('[data-gray-tile="container"]'));
    this.switchers = Array.prototype.slice.call(document.querySelectorAll('[data-switcher="container"]'));
    this.controlMenuTreeItems
        = Array.prototype.slice.call(document.querySelectorAll('[data-control-menu-tree="container"]'));
    this.sliders = Array.prototype.slice.call(document.querySelectorAll('[data-slider="container"]'));
    // this.feedbackItems = Array.prototype.slice.call(document.querySelectorAll('[data-feedback="container"]'));
    this.loader = document.querySelector('[data-loader]');
    this.feedbackSend = document.querySelector('[data-feedback-send="container"]');
    this.sidePopup = document.querySelector('[data-side-popup]');
    this.tabContentSliders
        = Array.prototype.slice.call(document.querySelectorAll('[data-tab-content-slider="container"]'));
    this.usingCompanies
        = Array.prototype.slice.call(document.querySelectorAll('[data-using-companies="container"]'));
    this.canvasLicense = document.querySelector('[data-canvas-license]');
    this.modalOpenItems = Array.prototype.slice.call(document.querySelectorAll('[data-modal-open]'));
    this.modal = document.querySelector('[data-modal="container"]');
    this.newsCategories
        = Array.prototype.slice.call(document.querySelectorAll('[data-news-categories="container"]'));
    this.news = document.querySelector('[data-news]');
    this.pressCenterNews
        = Array.prototype.slice.call(document.querySelectorAll('[data-press-center-news="container"]'));
    this.pressCenterSearch = document.querySelector('[data-press-center-search="container"]');
    this.pressCenterMedia
        = Array.prototype.slice.call(document.querySelectorAll('[data-press-center-media="container"]'));
    this.media = document.querySelector('[data-media]');
    this.buttonBack = document.querySelector('[data-button-back]');
    this.animationWordsWindow = document.querySelector('[data-animation-words-window]');
    this.panelMenus = Array.prototype.slice.call(document.querySelectorAll('[data-panel-menu="container"]'));
    this.onePageMenus = Array.prototype.slice.call(document.querySelectorAll('[data-one-page-menus="container"]'));
    this.comparisonEditions = document.querySelector('[data-comparison-editions]');
    this.newsUnit = document.querySelector('[data-news-unit]');
    this.consentUseCookies = document.querySelector('[data-consent-use-cookies="container"]');
    this.formInvoicing = document.querySelector('[data-form-invoicing]');
  }
  public initialize(): void {

    const priceStore: PriceStore = new PriceStore();
    const newsStore = new NewsStore();
    const downloadStore = new DownloadStore();
    this.tabControls.forEach((item: HTMLElement) => new SelectSolutionComponent(item, priceStore).initialize());
    this.interfaceTabs.forEach((item: HTMLElement) => new AssistantAppearanceComponent(item).initialize());
    this.visibilitySwitches.forEach((item: HTMLElement) => new VisibilitySwitchComponent(item).initialize());
    this.grayTiles.forEach((item: HTMLElement) => new GrayTileComponent(item).initialize());
    document.fonts.ready.then(() => {
      this.switchers.forEach((item: HTMLElement) => new SwitcherComponent(item).initialize());
    });
    this.tabControls.forEach(
        (item: HTMLElement, index: number) => new TabControlComponent(
          item,
          index,
          this.switchers,
          priceStore,
          newsStore,
          searchParams,
          this.loader,
          downloadStore
        ).initialize()
    );
    new OurPartnersPage(this.switchers, this.loader).initialize();
    new SuccessfulImplementationStories(this.switchers, this.loader).initialize();
    new PromotionsPage(this.switchers, this.loader).initialize();

    this.controlMenuTreeItems.forEach((item: HTMLElement) => new ControlMenuTreeComponent(
        item, window.innerWidth
      ).initialize()
    );
    this.controlMenuTreeItems.forEach((item: HTMLElement) => new SearchContentComponent(item).initialize());
    this.sliders.forEach((item: HTMLElement, index: number) => {
      const pricesSliderPage: PricesSliderPage = new PricesSliderPage(item, index, priceStore);
        pricesSliderPage.initialize();
      }
    );
    this.tabContentSliders.forEach((item: HTMLElement) => {
      item.classList.remove('default-inter-block-distance');
      new FeedbackComponent(item, priceStore).initialize();
    });
    if (this.feedbackSend) {
      new FeedbackSendPage(this.feedbackSend, this.loader, this.sidePopup).initialize();
      new FeedbackPlaceholderComponent(this.feedbackSend).initialize();
    }
    this.usingCompanies.forEach((item: HTMLElement) => new CompaniesAnimationComponent(item).initialize());
    if (this.canvasLicense) {
      new LicenseAnimationComponent(this.canvasLicense).initialize();
    }
    this.modalOpenItems.forEach((item: HTMLElement) => {
      if (this.modal) {
        const modal: HTMLElement = this.modal;
        item.addEventListener('click', () => {
          if (!item.hasAttribute('disabled')) {
            const tabParams = {switchers: this.switchers, priceStore, newsStore, searchParams};
            new ModalComponent(modal, item, '', tabParams, this.loader, downloadStore).initialize();
          }
        });
      }
    });
    new PressCenterPage().handlerToggle();
    new SwiperSettings().initialize();
    const uploadFile = document.querySelector('[data-upload-file="technological-compatibility"]');
    if (uploadFile) {
      new UploadFileComponent('/api/admin/uploading-technological-compatibility', this.loader);
    }

    if (this.news) {
      new NewsCategoryService(this.loader).getNewsCategory().then((data: InterfaceCategories | null): void => {
        if (data?.Categories) {
          new SwiperSettings().initialize();
          this.newsCategories.forEach(
              (item: HTMLElement) => new NewsCategories(
                  item,
                  data.Categories,
                  this.loader,
                  this.pressCenterNews,
                  newsStore
              ).initialize()
          );
        }
      });

      new NewsPageService(this.loader).getNews('true').then((dataFeaturedNews: InterfaceNews | null) => {
        new NewsPageService(this.loader).getNews().then((data: InterfaceNews | null) => {
          if (data?.News && dataFeaturedNews?.News) {
            newsStore.setFeaturedNews(dataFeaturedNews.News);
            new NewsPage(newsStore, this.loader, this.pressCenterNews, data.TotalCount).initialize();
            this.pressCenterNews.forEach((item: HTMLElement) => new NewsBody(
                item,
                data.News,
                data.TotalCount,
                dataFeaturedNews.News,
                newsStore,
                this.loader,
                this.pressCenterNews
            ).initialize());
          }
        });
      });
      if (this.pressCenterSearch) {
        new NewsSearch(this.pressCenterSearch, this.loader, newsStore, this.pressCenterNews).initialize()
      }
    }

    if (this.media) { // && searchParams.get('tab') === 'media'
      new MediaPageService(this.loader).getMedia().then((data: InterfaceMedia | null) => {
        if (data?.Publications) {
          new MediaPage(this.loader, this.pressCenterMedia, data.TotalCount).initialize();
          this.pressCenterMedia.forEach((item: HTMLElement) => {
            new MediaBody(item, data.Publications, data.TotalCount, this.loader).initialize();
          });
        }
      });
    }
    const historyUrl = localStorage.getItem('historyUrl');
    if (decodeURIComponent(currentUrl.pathname).search('история') === -1) {
      localStorage.setItem('historyUrl', currentUrl.href);
    }
    if (this.buttonBack && historyUrl) {
      this.buttonBack.classList.add('show');
      if (historyUrl) {
        this.buttonBack.addEventListener('click', () => {
          document.location.href = historyUrl;
        });
      } else {
        this.buttonBack.classList.add('hidden');
      }
    }

    if (this.animationWordsWindow) {
      // new AnimationMainPage(this.animationWordsWindow).initialize();
    }
    this.panelMenus.forEach((item: HTMLElement) => {
      new PanelMenuComponent(item).initialize()
    });
    this.onePageMenus.forEach((item: HTMLElement) => {
      new OnePageMenuComponent(item).initialize();
    })
    if (this.comparisonEditions) {
      new ComparisonEditionsPage().initialize();
    }
    if (this.newsUnit) {
      new NewsItemPage().initialize();
    }
    // document.cookie.split(";").forEach(function(c) {
    //   document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    // });
    if (this.consentUseCookies) {
      new PanelCookiesComponent(this.consentUseCookies).initialize()
    }
    this.panelMenus.forEach((item: HTMLElement) => {

      let heightAnchorScroll = item.offsetHeight;
      if (item.offsetHeight && this.onePageMenus.length > 0) {
        heightAnchorScroll = this.onePageMenus[0].offsetHeight + item.offsetHeight
        new SmoothTransitionAnchorLinks(heightAnchorScroll).initialize();
      }
    });
    if (this.formInvoicing) {
      new InvoicingPage(this.formInvoicing, this.loader, this.modal).initialize();
    }
  }
  resizeWindow() {
    window.addEventListener("resize", (event: UIEvent) => {
      const currentTarget: Window = event.currentTarget as Window;
      const innerWidth: number = currentTarget.innerWidth;
      this.controlMenuTreeItems.forEach((item: HTMLElement) => new ControlMenuTreeComponent(
          item, innerWidth
      ).initialize());
    });
  }

}
const app = new App();


const ready = (): void => {
  const close = document.querySelector('[data-close]');
  if (close) {
    close.addEventListener('click', () => {
      close.closest('[data-hiden-item]')?.classList.add('hidden');
    });
  }
  app.initialize();
  app.resizeWindow();
}
document.addEventListener("DOMContentLoaded", ready);
